import {
  type Chain,
  type ChainFormatters,
  type Client,
  type EstimateFeesPerGasReturnType,
  FeeValuesType,
  GetBlockReturnType,
  type PublicClient,
  type Transport,
  defineChain,
  hexToBigInt,
  parseGwei,
} from 'viem';

export const isProduction =
  process.env.REACT_APP_VERCEL_ENV === 'production' ||
  process.env.NEXT_PUBLIC_VERCEL_ENV === 'production' ||
  process.env.VERCEL_ENV === 'production';

export const sankoTestnet = defineChain({
  id: 1992,
  name: 'Sanko Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Testnet DMT',
    symbol: 'tDMT',
  },
  rpcUrls: {
    default: {
      http: ['https://sanko-arb-sepolia.rpc.caldera.xyz/http'],
      webSocket: ['wss://sanko-arb-sepolia.rpc.caldera.xyz/ws'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Sanko Testnet Explorer',
      url: 'https://testnet.sankoscan.io/',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 5882,
    },
  },
});

export const sankoMainnet = defineChain({
  id: 1996,
  name: 'Sanko',
  nativeCurrency: {
    decimals: 18,
    name: 'DMT',
    symbol: 'DMT',
  },
  rpcUrls: {
    default: {
      http: ['https://mainnet.sanko.xyz'],
      webSocket: ['wss://mainnet.sanko.xyz/ws'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Sanko Tools',
      url: 'https://tools.sanko.xyz',
    },
    blockscout: {
      name: 'Sanko Explorer',
      url: 'https://explorer.sanko.xyz',
    },
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11',
      blockCreated: 5882,
    },
    ensUniversalResolver: {
      address: '0xE6948912778506bf20896632c35163b1fACD5464',
    },
  },
});

export const SANKO_CHAIN = isProduction ? sankoMainnet : sankoTestnet;
